<div class="container">
  <div class="tos-card card shadow">
    <div
      class="card-body"
      [ngStyle]="{
        'overflow-y': tosContent() ? 'scroll' : 'auto',
      }"
    >
      @if (errorMessage(); as errorMessage) {
        <mop-alert [type]="'danger'">
          {{ errorMessage }}
        </mop-alert>
      }

      @if (tosContent()) {
        <div class="mb-3">
          <div [innerHtml]="tosContent()"></div>
          <p class="text-center">
            <strong>&copy; {{ currentYear }}, Trimble Inc.</strong>
          </p>
        </div>
      } @else {
        <div class="text-center text-primary">
          <div class="spinner-border"></div>
          <div class="h3 text-primary mt-3">Loading Terms...</div>
        </div>
      }
    </div>

    @if (showAcceptButton()) {
      <div class="card-footer d-flex justify-content-end gap-3">
        <mop-button
          [type]="'primary'"
          [style]="'solid'"
          [disabled]="loading()"
          [loading]="loading()"
          [text]="loading() ? 'Accepting...' : 'Accept Terms'"
          (buttonClicked)="acceptTermsOfService()"
        ></mop-button>
      </div>
    }
  </div>
</div>
